import { defineStore } from 'pinia';
import { getUser, createUser, changeEmail, changeEmailVerify, createUserVerify } from '@/api/users';
import type { UserEditableData, User, FetchedItem, UserChangeEmailData } from '@/types';

export const useUserStore = defineStore('userStore', {
  state: (): { user: FetchedItem<User> } => ({
    user: undefined,
  }),
  getters: {
    isTotpLocked: (state) =>
      !!state.user && state.user.hasTotpRequiredOrg && !state.user.totpEnabled,
  },
  actions: {
    async getUser() {
      try {
        this.user = await getUser();
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    async createUser({
      userEmail,
      userPassword,
      organizationInviteToken,
    }: UserEditableData) {
      try {
        await createUser({
          userEmail,
          userPassword,
          organizationInviteToken,
        });
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    async verifyUser(registrationRequestId: string) {
      try {
        return createUserVerify(registrationRequestId);
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    async changeEmail({ newUserEmail, isPrimary, password }: UserChangeEmailData) {
      try {
        return changeEmail({ newUserEmail, isPrimary, password });
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    async changeEmailVerify(verificationRequestId: string) {
      try {
        return changeEmailVerify(verificationRequestId);
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  },
});
